export default __webpack_public_path__ + "static/media/info-img6.11b667b2.png";